// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/planning.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/planning.proto.
 */
export const file_travplaces_v1_planning: GenFile = /*@__PURE__*/
  fileDesc("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", [file_travplaces_v1_audit, file_travplaces_v1_authz, file_google_protobuf_timestamp]);

/**
 * LatLng is a single coordinate. Note that some legacy geometries are stored
 * in GeoJSON [lng, lat] order; here they are always addressed by name, so the
 * service is responsible for placing longitude in `lng` and latitude in `lat`.
 *
 * @generated from message travplaces.v1.LatLng
 */
export type LatLng = Message<"travplaces.v1.LatLng"> & {
  /**
   * @generated from field: double lat = 1;
   */
  lat: number;

  /**
   * @generated from field: double lng = 2;
   */
  lng: number;
};

/**
 * Describes the message travplaces.v1.LatLng.
 * Use `create(LatLngSchema)` to create a new message.
 */
export const LatLngSchema: GenMessage<LatLng> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 0);

/**
 * Polyline is an ordered run of coordinates — one line the plan may not
 * reuse, one geometry, one polygon ring.
 *
 * @generated from message travplaces.v1.Polyline
 */
export type Polyline = Message<"travplaces.v1.Polyline"> & {
  /**
   * @generated from field: repeated travplaces.v1.LatLng points = 1;
   */
  points: LatLng[];
};

/**
 * Describes the message travplaces.v1.Polyline.
 * Use `create(PolylineSchema)` to create a new message.
 */
export const PolylineSchema: GenMessage<Polyline> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 1);

/**
 * PlaceRef names an endpoint either by coordinate or by POI id. `kind` is
 * "coords" or "poi"; coordinate refs read lat/lng/label, poi refs read poi_id.
 *
 * @generated from message travplaces.v1.PlaceRef
 */
export type PlaceRef = Message<"travplaces.v1.PlaceRef"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: double lat = 2;
   */
  lat: number;

  /**
   * @generated from field: double lng = 3;
   */
  lng: number;

  /**
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * @generated from field: string poi_id = 5;
   */
  poiId: string;
};

/**
 * Describes the message travplaces.v1.PlaceRef.
 * Use `create(PlaceRefSchema)` to create a new message.
 */
export const PlaceRefSchema: GenMessage<PlaceRef> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 2);

/**
 * CoordStop is a spot identified only by position.
 *
 * @generated from message travplaces.v1.CoordStop
 */
export type CoordStop = Message<"travplaces.v1.CoordStop"> & {
  /**
   * @generated from field: double lat = 1;
   */
  lat: number;

  /**
   * @generated from field: double lng = 2;
   */
  lng: number;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: int32 dwell_minutes = 4;
   */
  dwellMinutes: number;
};

/**
 * Describes the message travplaces.v1.CoordStop.
 * Use `create(CoordStopSchema)` to create a new message.
 */
export const CoordStopSchema: GenMessage<CoordStop> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 3);

/**
 * BreakRequest asks for a lunch or coffee break somewhere near where the
 * traveller will be when it is due.
 *
 * @generated from message travplaces.v1.BreakRequest
 */
export type BreakRequest = Message<"travplaces.v1.BreakRequest"> & {
  /**
   * A place chosen for this break. Empty means the planner picks one.
   *
   * @generated from field: string poi_id = 1;
   */
  poiId: string;

  /**
   * @generated from field: int32 target_minutes_from_start = 2;
   */
  targetMinutesFromStart: number;

  /**
   * @generated from field: int32 duration_minutes = 3;
   */
  durationMinutes: number;

  /**
   * @generated from field: int32 flexibility_minutes = 4;
   */
  flexibilityMinutes: number;

  /**
   * True when the break has no particular hour and the planner should fit it
   * wherever the round allows. The target above is then ignored.
   *
   * The default for a new round: most people want lunch somewhere in the
   * middle rather than at 1:00 exactly, and a hard window they never asked
   * for is the commonest reason a break cannot be placed at all.
   *
   * @generated from field: bool anytime = 5;
   */
  anytime: boolean;
};

/**
 * Describes the message travplaces.v1.BreakRequest.
 * Use `create(BreakRequestSchema)` to create a new message.
 */
export const BreakRequestSchema: GenMessage<BreakRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 4);

/**
 * ViaPoint shapes the path without becoming a stop: no dwell, no place in the
 * itinerary.
 *
 * @generated from message travplaces.v1.ViaPoint
 */
export type ViaPoint = Message<"travplaces.v1.ViaPoint"> & {
  /**
   * @generated from field: double lat = 1;
   */
  lat: number;

  /**
   * @generated from field: double lng = 2;
   */
  lng: number;

  /**
   * @generated from field: int32 after_stop_index = 3;
   */
  afterStopIndex: number;
};

/**
 * Describes the message travplaces.v1.ViaPoint.
 * Use `create(ViaPointSchema)` to create a new message.
 */
export const ViaPointSchema: GenMessage<ViaPoint> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 5);

/**
 * AvoidSpec is everything a plan is told to hold clear of.
 *
 * @generated from message travplaces.v1.AvoidSpec
 */
export type AvoidSpec = Message<"travplaces.v1.AvoidSpec"> & {
  /**
   * @generated from field: repeated string poi_ids = 1;
   */
  poiIds: string[];

  /**
   * @generated from field: repeated string category_keys = 2;
   */
  categoryKeys: string[];

  /**
   * @generated from field: repeated travplaces.v1.CoordStop points = 3;
   */
  points: CoordStop[];

  /**
   * @generated from field: optional double distance_m = 4;
   */
  distanceM?: number | undefined;

  /**
   * Per-place and per-category radii. Each beats the one below it.
   *
   * @generated from field: map<string, double> distance_by_poi_id = 5;
   */
  distanceByPoiId: { [key: string]: number };

  /**
   * @generated from field: map<string, double> distance_by_category_key = 6;
   */
  distanceByCategoryKey: { [key: string]: number };
};

/**
 * Describes the message travplaces.v1.AvoidSpec.
 * Use `create(AvoidSpecSchema)` to create a new message.
 */
export const AvoidSpecSchema: GenMessage<AvoidSpec> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 6);

/**
 * RoutingOptions answers the router's road questions. Values are 0..1
 * preferences except `shortest`, which is a flag.
 *
 * @generated from message travplaces.v1.RoutingOptions
 */
export type RoutingOptions = Message<"travplaces.v1.RoutingOptions"> & {
  /**
   * @generated from field: optional double use_highways = 1;
   */
  useHighways?: number | undefined;

  /**
   * @generated from field: optional double use_tolls = 2;
   */
  useTolls?: number | undefined;

  /**
   * @generated from field: optional double use_ferry = 3;
   */
  useFerry?: number | undefined;

  /**
   * @generated from field: optional double use_living_streets = 4;
   */
  useLivingStreets?: number | undefined;

  /**
   * @generated from field: optional bool shortest = 5;
   */
  shortest?: boolean | undefined;

  /**
   *
   * Main roads — motorway, trunk and primary together.
   *
   * NOT a Valhalla costing option, and never sent to it: the router has no
   * lever for road classes below motorway, which is why "avoid motorways"
   * leaves a route 88% on arterials and looking like a motorway anyway. It
   * is answered on the CANDIDATES instead, measured per edge through
   * trace_attributes, in the same way the motorway answer is.
   *
   * @generated from field: optional double use_main_roads = 6;
   */
  useMainRoads?: number | undefined;

  /**
   *
   * Residential streets — `highway=residential`, the ordinary streets people
   * live on.
   *
   * The class a traveller means by "take me through the city", and the one
   * Valhalla has no costing option for at all: use_living_streets acts on
   * `highway=living_street`, a shared-surface woonerf that is a different
   * thing and, in an American city, a few dozen disconnected fragments.
   * Measured per edge and answered on the candidates, like main roads.
   *
   * @generated from field: optional double use_residential = 7;
   */
  useResidential?: number | undefined;
};

/**
 * Describes the message travplaces.v1.RoutingOptions.
 * Use `create(RoutingOptionsSchema)` to create a new message.
 */
export const RoutingOptionsSchema: GenMessage<RoutingOptions> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 7);

/**
 * RouteCharacteristics is what the journey should feel like, 0..1 each,
 * measured against our own places rather than the router's.
 *
 * @generated from message travplaces.v1.RouteCharacteristics
 */
export type RouteCharacteristics = Message<"travplaces.v1.RouteCharacteristics"> & {
  /**
   * @generated from field: optional double safety = 1;
   */
  safety?: number | undefined;

  /**
   * @generated from field: optional double scenic = 2;
   */
  scenic?: number | undefined;

  /**
   * @generated from field: optional double quiet = 3;
   */
  quiet?: number | undefined;
};

/**
 * Describes the message travplaces.v1.RouteCharacteristics.
 * Use `create(RouteCharacteristicsSchema)` to create a new message.
 */
export const RouteCharacteristicsSchema: GenMessage<RouteCharacteristics> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 8);

/**
 * PathOptions are the numbers that weigh routing and characteristics.
 *
 * @generated from message travplaces.v1.PathOptions
 */
export type PathOptions = Message<"travplaces.v1.PathOptions"> & {
  /**
   * @generated from field: optional double road_radius_m = 1;
   */
  roadRadiusM?: number | undefined;

  /**
   * @generated from field: optional double extra_pct = 2;
   */
  extraPct?: number | undefined;

  /**
   * @generated from field: optional double extra_minutes = 3;
   */
  extraMinutes?: number | undefined;

  /**
   * @generated from field: optional double different_path_buffer_m = 4;
   */
  differentPathBufferM?: number | undefined;

  /**
   * @generated from field: optional double different_path_keep_clear_m = 5;
   */
  differentPathKeepClearM?: number | undefined;
};

/**
 * Describes the message travplaces.v1.PathOptions.
 * Use `create(PathOptionsSchema)` to create a new message.
 */
export const PathOptionsSchema: GenMessage<PathOptions> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 9);

/**
 * PlanRequest is the full instruction for one planned day. Mirrors
 * PlanRequest in the legacy types.ts.
 *
 * @generated from message travplaces.v1.PlanRequest
 */
export type PlanRequest = Message<"travplaces.v1.PlanRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * @generated from field: travplaces.v1.PlaceRef start = 2;
   */
  start?: PlaceRef | undefined;

  /**
   * @generated from field: travplaces.v1.PlaceRef end = 3;
   */
  end?: PlaceRef | undefined;

  /**
   * @generated from field: string mode = 4;
   */
  mode: string;

  /**
   * @generated from field: optional string start_time = 5;
   */
  startTime?: string | undefined;

  /**
   * YYYY-MM-DD in the city's timezone. Opening hours read against its weekday.
   *
   * @generated from field: optional string date = 6;
   */
  date?: string | undefined;

  /**
   * @generated from field: optional int32 available_minutes = 7;
   */
  availableMinutes?: number | undefined;

  /**
   * @generated from field: optional string route_style_key = 8;
   */
  routeStyleKey?: string | undefined;

  /**
   * Several presets at once. Categories combine; the first sets pacing.
   *
   * @generated from field: repeated string route_style_keys = 9;
   */
  routeStyleKeys: string[];

  /**
   * A themed day: a share of stops reserved for the theme before optimising.
   *
   * @generated from field: optional string theme_key = 10;
   */
  themeKey?: string | undefined;

  /**
   * @generated from field: repeated string must_visit_poi_ids = 11;
   */
  mustVisitPoiIds: string[];

  /**
   * @generated from field: repeated string interest_category_keys = 12;
   */
  interestCategoryKeys: string[];

  /**
   * Ranked higher among those, without a promised share.
   *
   * @generated from field: repeated string boost_category_keys = 13;
   */
  boostCategoryKeys: string[];

  /**
   * Stay time per kind of site, for this round. Beats the emphasis's.
   *
   * @generated from field: map<string, int32> dwell_minutes_by_category_key = 14;
   */
  dwellMinutesByCategoryKey: { [key: string]: number };

  /**
   * Places never to suggest — removed from the itinerary by hand.
   *
   * @generated from field: repeated string exclude_poi_ids = 15;
   */
  excludePoiIds: string[];

  /**
   * @generated from field: repeated travplaces.v1.CoordStop must_visit_points = 16;
   */
  mustVisitPoints: CoordStop[];

  /**
   * @generated from field: travplaces.v1.AvoidSpec avoid = 17;
   */
  avoid?: AvoidSpec | undefined;

  /**
   * "off" | "prefer"
   *
   * @generated from field: string safety_preference = 18;
   */
  safetyPreference: string;

  /**
   * @generated from field: optional travplaces.v1.BreakRequest lunch = 19;
   */
  lunch?: BreakRequest | undefined;

  /**
   * @generated from field: optional travplaces.v1.BreakRequest coffee = 20;
   */
  coffee?: BreakRequest | undefined;

  /**
   * @generated from field: optional bool avoid_tolls = 21;
   */
  avoidTolls?: boolean | undefined;

  /**
   * @generated from field: optional int32 max_stops = 22;
   */
  maxStops?: number | undefined;

  /**
   * Visit the stops in exactly the order given, rather than optimising it.
   *
   * @generated from field: optional bool stop_order_locked = 23;
   */
  stopOrderLocked?: boolean | undefined;

  /**
   * @generated from field: optional travplaces.v1.RoutingOptions routing_options = 24;
   */
  routingOptions?: RoutingOptions | undefined;

  /**
   * @generated from field: optional travplaces.v1.RouteCharacteristics route_characteristics = 25;
   */
  routeCharacteristics?: RouteCharacteristics | undefined;

  /**
   * @generated from field: optional travplaces.v1.PathOptions path_options = 26;
   */
  pathOptions?: PathOptions | undefined;

  /**
   * Lines this route may not reuse — normally the plan already on screen.
   *
   * @generated from field: repeated travplaces.v1.Polyline different_from = 27;
   */
  differentFrom: Polyline[];

  /**
   * The visiting order, as candidate ids: a place id, or "pin-N" for the Nth
   * must_visit_points entry. Read only when stop_order_locked is set.
   *
   * @generated from field: repeated string stop_order = 28;
   */
  stopOrder: string[];

  /**
   * @generated from field: repeated travplaces.v1.ViaPoint via_points = 29;
   */
  viaPoints: ViaPoint[];

  /**
   * Dwell overrides per stop, keyed as stop_order is (place id or "pin-N").
   *
   * @generated from field: map<string, int32> stop_dwell_minutes = 30;
   */
  stopDwellMinutes: { [key: string]: number };

  /**
   * How to travel out of particular stops. Keyed by the stop each leg LEAVES:
   * "start", then a place id, then "at:N" for a stop with no id.
   *
   * @generated from field: map<string, string> leg_modes = 31;
   */
  legModes: { [key: string]: string };
};

/**
 * Describes the message travplaces.v1.PlanRequest.
 * Use `create(PlanRequestSchema)` to create a new message.
 */
export const PlanRequestSchema: GenMessage<PlanRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 10);

/**
 * RouteStop is one point on the itinerary. `kind` is
 * "start" | "end" | "visit" | "lunch" | "coffee".
 *
 * @generated from message travplaces.v1.RouteStop
 */
export type RouteStop = Message<"travplaces.v1.RouteStop"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * Empty for a coordinate stop with no POI behind it.
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: double lat = 4;
   */
  lat: number;

  /**
   * @generated from field: double lng = 5;
   */
  lng: number;

  /**
   * @generated from field: optional string category_key = 6;
   */
  categoryKey?: string | undefined;

  /**
   * @generated from field: int32 arrival_minutes = 7;
   */
  arrivalMinutes: number;

  /**
   * @generated from field: int32 departure_minutes = 8;
   */
  departureMinutes: number;

  /**
   * @generated from field: int32 dwell_minutes = 9;
   */
  dwellMinutes: number;

  /**
   * @generated from field: string arrival_time = 10;
   */
  arrivalTime: string;

  /**
   * @generated from field: string departure_time = 11;
   */
  departureTime: string;

  /**
   * @generated from field: optional string note = 12;
   */
  note?: string | undefined;

  /**
   * Null in legacy when unknown; carried as an explicit tri-state.
   *
   * @generated from field: optional bool outside_opening_hours = 13;
   */
  outsideOpeningHours?: boolean | undefined;
};

/**
 * Describes the message travplaces.v1.RouteStop.
 * Use `create(RouteStopSchema)` to create a new message.
 */
export const RouteStopSchema: GenMessage<RouteStop> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 11);

/**
 * TransitLegDetail describes one vehicle inside a transit leg.
 *
 * @generated from message travplaces.v1.TransitLegDetail
 */
export type TransitLegDetail = Message<"travplaces.v1.TransitLegDetail"> & {
  /**
   * @generated from field: string mode = 1;
   */
  mode: string;

  /**
   * @generated from field: optional string route_name = 2;
   */
  routeName?: string | undefined;

  /**
   * @generated from field: optional string headsign = 3;
   */
  headsign?: string | undefined;

  /**
   * @generated from field: optional string from_stop = 4;
   */
  fromStop?: string | undefined;

  /**
   * @generated from field: optional string to_stop = 5;
   */
  toStop?: string | undefined;

  /**
   * @generated from field: int32 duration_minutes = 6;
   */
  durationMinutes: number;
};

/**
 * Describes the message travplaces.v1.TransitLegDetail.
 * Use `create(TransitLegDetailSchema)` to create a new message.
 */
export const TransitLegDetailSchema: GenMessage<TransitLegDetail> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 12);

/**
 * Maneuver is one turn of a leg, in the router's own words.
 *
 * Produced by the same /route call the drawn line comes from, but asked for
 * separately: see PlanDirections. A plan is re-sent on every edit and kept in
 * every saved route, and the narrative is wanted once, by somebody asking for
 * a file, so it does not ride along.
 *
 * @generated from message travplaces.v1.Maneuver
 */
export type Maneuver = Message<"travplaces.v1.Maneuver"> & {
  /**
   * The sentence a driver is given, e.g. "Turn right onto Main Street".
   *
   * @generated from field: string instruction = 1;
   */
  instruction: string;

  /**
   * @generated from field: repeated string street_names = 2;
   */
  streetNames: string[];

  /**
   * @generated from field: double distance_m = 3;
   */
  distanceM: number;

  /**
   * @generated from field: double time_s = 4;
   */
  timeS: number;

  /**
   * Valhalla's own maneuver type, so a destination can be told from a turn
   * without parsing the sentence.
   *
   * @generated from field: int32 type = 5;
   */
  type: number;

  /**
   * Where the turn happens, off the leg's own shape. An instruction with no
   * position is of no use to a GPX reader.
   *
   * @generated from field: double lat = 6;
   */
  lat: number;

  /**
   * @generated from field: double lng = 7;
   */
  lng: number;
};

/**
 * Describes the message travplaces.v1.Maneuver.
 * Use `create(ManeuverSchema)` to create a new message.
 */
export const ManeuverSchema: GenMessage<Maneuver> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 13);

/**
 * RouteLeg is the travel between two consecutive stops. Geometry is the
 * ordered coordinates of the drawn line.
 *
 * @generated from message travplaces.v1.RouteLeg
 */
export type RouteLeg = Message<"travplaces.v1.RouteLeg"> & {
  /**
   * @generated from field: int32 from_index = 1;
   */
  fromIndex: number;

  /**
   * @generated from field: int32 to_index = 2;
   */
  toIndex: number;

  /**
   * @generated from field: string mode = 3;
   */
  mode: string;

  /**
   * @generated from field: double distance_m = 4;
   */
  distanceM: number;

  /**
   * @generated from field: double time_s = 5;
   */
  timeS: number;

  /**
   * @generated from field: repeated travplaces.v1.LatLng geometry = 6;
   */
  geometry: LatLng[];

  /**
   * @generated from field: repeated travplaces.v1.TransitLegDetail transit_detail = 7;
   */
  transitDetail: TransitLegDetail[];
};

/**
 * Describes the message travplaces.v1.RouteLeg.
 * Use `create(RouteLegSchema)` to create a new message.
 */
export const RouteLegSchema: GenMessage<RouteLeg> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 14);

/**
 * ExcludePolygon is one ring of ground to keep out of. A message rather than
 * a bare repeated field because proto has no repeated-of-repeated.
 *
 * @generated from message travplaces.v1.ExcludePolygon
 */
export type ExcludePolygon = Message<"travplaces.v1.ExcludePolygon"> & {
  /**
   * @generated from field: repeated travplaces.v1.LatLng ring = 1;
   */
  ring: LatLng[];
};

/**
 * Describes the message travplaces.v1.ExcludePolygon.
 * Use `create(ExcludePolygonSchema)` to create a new message.
 */
export const ExcludePolygonSchema: GenMessage<ExcludePolygon> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 15);

/**
 * DirectionsLeg is one leg's worth of turn-by-turn, for export.
 *
 * No geometry: the caller already holds the drawn line, and the only thing
 * missing from it is the words.
 *
 * @generated from message travplaces.v1.DirectionsLeg
 */
export type DirectionsLeg = Message<"travplaces.v1.DirectionsLeg"> & {
  /**
   * @generated from field: int32 from_index = 1;
   */
  fromIndex: number;

  /**
   * @generated from field: int32 to_index = 2;
   */
  toIndex: number;

  /**
   * @generated from field: double distance_m = 3;
   */
  distanceM: number;

  /**
   * @generated from field: double time_s = 4;
   */
  timeS: number;

  /**
   * @generated from field: repeated travplaces.v1.Maneuver maneuvers = 5;
   */
  maneuvers: Maneuver[];
};

/**
 * Describes the message travplaces.v1.DirectionsLeg.
 * Use `create(DirectionsLegSchema)` to create a new message.
 */
export const DirectionsLegSchema: GenMessage<DirectionsLeg> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 16);

/**
 * @generated from message travplaces.v1.PlanDirectionsRequest
 */
export type PlanDirectionsRequest = Message<"travplaces.v1.PlanDirectionsRequest"> & {
  /**
   * The request the plan was made from, so the costing, the road answers and
   * the toll preference are the ones that drew the line.
   *
   * @generated from field: travplaces.v1.PlanRequest plan = 1;
   */
  plan?: PlanRequest | undefined;

  /**
   * The stops in the order the plan settled on, start first and end last.
   *
   * Sent rather than re-derived. The order came out of the optimiser, and
   * running it again could answer differently — directions that disagree with
   * the itinerary beside them are worse than none.
   *
   * @generated from field: repeated travplaces.v1.LatLng points = 2;
   */
  points: LatLng[];

  /**
   * The exclusions the plan honoured, as the plan itself reported them, so
   * the words follow the line that was drawn rather than a shorter one
   * through the ground it avoided.
   *
   * @generated from field: repeated travplaces.v1.ExcludePolygon exclude = 3;
   */
  exclude: ExcludePolygon[];
};

/**
 * Describes the message travplaces.v1.PlanDirectionsRequest.
 * Use `create(PlanDirectionsRequestSchema)` to create a new message.
 */
export const PlanDirectionsRequestSchema: GenMessage<PlanDirectionsRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 17);

/**
 * @generated from message travplaces.v1.PlanDirectionsResponse
 */
export type PlanDirectionsResponse = Message<"travplaces.v1.PlanDirectionsResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.DirectionsLeg legs = 1;
   */
  legs: DirectionsLeg[];
};

/**
 * Describes the message travplaces.v1.PlanDirectionsResponse.
 * Use `create(PlanDirectionsResponseSchema)` to create a new message.
 */
export const PlanDirectionsResponseSchema: GenMessage<PlanDirectionsResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 18);

/**
 * AvoidedZone is an exclusion the plan honoured (or, on transit, could not).
 *
 * @generated from message travplaces.v1.AvoidedZone
 */
export type AvoidedZone = Message<"travplaces.v1.AvoidedZone"> & {
  /**
   * @generated from field: string poi_id = 1;
   */
  poiId: string;

  /**
   * Set when the zone came from an avoided category rather than a place.
   *
   * @generated from field: optional string from_category_key = 2;
   */
  fromCategoryKey?: string | undefined;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string category_key = 4;
   */
  categoryKey: string;

  /**
   * @generated from field: double lat = 5;
   */
  lat: number;

  /**
   * @generated from field: double lng = 6;
   */
  lng: number;

  /**
   * @generated from field: double radius_m = 7;
   */
  radiusM: number;

  /**
   * @generated from field: repeated travplaces.v1.LatLng polygon = 8;
   */
  polygon: LatLng[];

  /**
   * Only possible on transit, which cannot honour polygon exclusions.
   *
   * @generated from field: bool violated = 9;
   */
  violated: boolean;
};

/**
 * Describes the message travplaces.v1.AvoidedZone.
 * Use `create(AvoidedZoneSchema)` to create a new message.
 */
export const AvoidedZoneSchema: GenMessage<AvoidedZone> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 19);

/**
 * RouteTotals aggregates the plan's time and distance.
 *
 * @generated from message travplaces.v1.RouteTotals
 */
export type RouteTotals = Message<"travplaces.v1.RouteTotals"> & {
  /**
   * @generated from field: int32 travel_minutes = 1;
   */
  travelMinutes: number;

  /**
   * @generated from field: int32 dwell_minutes = 2;
   */
  dwellMinutes: number;

  /**
   * @generated from field: int32 total_minutes = 3;
   */
  totalMinutes: number;

  /**
   * @generated from field: double distance_meters = 4;
   */
  distanceMeters: number;
};

/**
 * Describes the message travplaces.v1.RouteTotals.
 * Use `create(RouteTotalsSchema)` to create a new message.
 */
export const RouteTotalsSchema: GenMessage<RouteTotals> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 20);

/**
 * ThemeOutcome reports what a theme delivered against what it promised.
 *
 * @generated from message travplaces.v1.ThemeOutcome
 */
export type ThemeOutcome = Message<"travplaces.v1.ThemeOutcome"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: double min_share = 3;
   */
  minShare: number;

  /**
   * @generated from field: int32 non_anchor_stops = 4;
   */
  nonAnchorStops: number;

  /**
   * @generated from field: int32 on_theme_stops = 5;
   */
  onThemeStops: number;

  /**
   * @generated from field: double share = 6;
   */
  share: number;

  /**
   * @generated from field: bool met = 7;
   */
  met: boolean;
};

/**
 * Describes the message travplaces.v1.ThemeOutcome.
 * Use `create(ThemeOutcomeSchema)` to create a new message.
 */
export const ThemeOutcomeSchema: GenMessage<ThemeOutcome> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 21);

/**
 * IpsCategoryBreakdown is one category's contribution to the proximity score.
 *
 * @generated from message travplaces.v1.IpsCategoryBreakdown
 */
export type IpsCategoryBreakdown = Message<"travplaces.v1.IpsCategoryBreakdown"> & {
  /**
   * @generated from field: string category_key = 1;
   */
  categoryKey: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: double weight = 3;
   */
  weight: number;

  /**
   * Renormalised across enabled categories; these sum to 1.
   *
   * @generated from field: double effective_weight = 4;
   */
  effectiveWeight: number;

  /**
   * r(c): inside this, a waypoint scores a full mark.
   *
   * @generated from field: double radius_m = 5;
   */
  radiusM: number;

  /**
   * @generated from field: int32 facilities_within_radius = 6;
   */
  facilitiesWithinRadius: number;

  /**
   * @generated from field: optional double worst_waypoint_distance_m = 7;
   */
  worstWaypointDistanceM?: number | undefined;

  /**
   * C(c): the mean across every waypoint.
   *
   * @generated from field: double category_score = 8;
   */
  categoryScore: number;
};

/**
 * Describes the message travplaces.v1.IpsCategoryBreakdown.
 * Use `create(IpsCategoryBreakdownSchema)` to create a new message.
 */
export const IpsCategoryBreakdownSchema: GenMessage<IpsCategoryBreakdown> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 22);

/**
 * IpsAssessment measures how close the stops sit to published facilities.
 *
 * @generated from message travplaces.v1.IpsAssessment
 */
export type IpsAssessment = Message<"travplaces.v1.IpsAssessment"> & {
  /**
   * 0..100
   *
   * @generated from field: double score = 1;
   */
  score: number;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string disclaimer = 3;
   */
  disclaimer: string;

  /**
   * @generated from field: int32 waypoint_count = 4;
   */
  waypointCount: number;

  /**
   * @generated from field: repeated travplaces.v1.IpsCategoryBreakdown breakdown = 5;
   */
  breakdown: IpsCategoryBreakdown[];
};

/**
 * Describes the message travplaces.v1.IpsAssessment.
 * Use `create(IpsAssessmentSchema)` to create a new message.
 */
export const IpsAssessmentSchema: GenMessage<IpsAssessment> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 23);

/**
 * DroppedStop is a place the optimiser could not fit.
 *
 * @generated from message travplaces.v1.DroppedStop
 */
export type DroppedStop = Message<"travplaces.v1.DroppedStop"> & {
  /**
   * @generated from field: string poi_id = 1;
   */
  poiId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message travplaces.v1.DroppedStop.
 * Use `create(DroppedStopSchema)` to create a new message.
 */
export const DroppedStopSchema: GenMessage<DroppedStop> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 24);

/**
 * PlanSuggestion is present when a larger time budget would recover stops.
 *
 * @generated from message travplaces.v1.PlanSuggestion
 */
export type PlanSuggestion = Message<"travplaces.v1.PlanSuggestion"> & {
  /**
   * @generated from field: int32 available_minutes = 1;
   */
  availableMinutes: number;

  /**
   * @generated from field: int32 recovers = 2;
   */
  recovers: number;
};

/**
 * Describes the message travplaces.v1.PlanSuggestion.
 * Use `create(PlanSuggestionSchema)` to create a new message.
 */
export const PlanSuggestionSchema: GenMessage<PlanSuggestion> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 25);

/**
 * RouteAlternative is another way round for the same endpoints. Direct
 * routes only, so often empty.
 *
 * @generated from message travplaces.v1.RouteAlternative
 */
export type RouteAlternative = Message<"travplaces.v1.RouteAlternative"> & {
  /**
   * @generated from field: int32 index = 1;
   */
  index: number;

  /**
   * @generated from field: double distance_meters = 2;
   */
  distanceMeters: number;

  /**
   * @generated from field: double duration_minutes = 3;
   */
  durationMinutes: number;

  /**
   * @generated from field: repeated travplaces.v1.LatLng geometry = 4;
   */
  geometry: LatLng[];

  /**
   *
   * How this way round answers the road that was asked for, against the one
   * drawn — e.g. "6.9 km on motorway, 0.6 km less than this route".
   *
   * Empty unless a road control was answered, because with no question asked
   * there is nothing to answer. Offered because the list was a trap without
   * it: having preferred motorways and been given the line carrying most,
   * the alternatives are by construction the ones carrying LESS, and they
   * were shown as equal-looking options that silently undid the preference.
   *
   * @generated from field: string road_answer = 5;
   */
  roadAnswer: string;
};

/**
 * Describes the message travplaces.v1.RouteAlternative.
 * Use `create(RouteAlternativeSchema)` to create a new message.
 */
export const RouteAlternativeSchema: GenMessage<RouteAlternative> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 26);

/**
 * RoutePlan is the planned day. Mirrors RoutePlan in the legacy types.ts,
 * with the task's flat totals (total_distance_m, total_time_s) added beside
 * the structured RouteTotals.
 *
 * @generated from message travplaces.v1.RoutePlan
 */
export type RoutePlan = Message<"travplaces.v1.RoutePlan"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * @generated from field: string mode = 2;
   */
  mode: string;

  /**
   * @generated from field: optional string style_key = 3;
   */
  styleKey?: string | undefined;

  /**
   * Every style applied, in the order given.
   *
   * @generated from field: repeated string style_keys = 4;
   */
  styleKeys: string[];

  /**
   * What a theme delivered, when one was asked for.
   *
   * @generated from field: optional travplaces.v1.ThemeOutcome theme = 5;
   */
  theme?: ThemeOutcome | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 6;
   */
  generatedAt?: Timestamp | undefined;

  /**
   * @generated from field: string start_time = 7;
   */
  startTime: string;

  /**
   * @generated from field: repeated travplaces.v1.RouteStop stops = 8;
   */
  stops: RouteStop[];

  /**
   * @generated from field: repeated travplaces.v1.RouteLeg legs = 9;
   */
  legs: RouteLeg[];

  /**
   * @generated from field: repeated travplaces.v1.AvoidedZone avoided_zones = 10;
   */
  avoidedZones: AvoidedZone[];

  /**
   * @generated from field: travplaces.v1.RouteTotals totals = 11;
   */
  totals?: RouteTotals | undefined;

  /**
   * Flat convenience totals mirroring the structured RouteTotals.
   *
   * @generated from field: double total_distance_m = 12;
   */
  totalDistanceM: number;

  /**
   * @generated from field: double total_time_s = 13;
   */
  totalTimeS: number;

  /**
   * Proximity of the stops to published facilities. Unset on old saved plans.
   *
   * @generated from field: optional travplaces.v1.IpsAssessment infrastructure_proximity = 14;
   */
  infrastructureProximity?: IpsAssessment | undefined;

  /**
   * @generated from field: repeated travplaces.v1.DroppedStop dropped = 15;
   */
  dropped: DroppedStop[];

  /**
   * @generated from field: optional travplaces.v1.PlanSuggestion suggestion = 16;
   */
  suggestion?: PlanSuggestion | undefined;

  /**
   * Other ways round. Only produced for a direct route, so often empty.
   *
   * @generated from field: repeated travplaces.v1.RouteAlternative alternatives = 17;
   */
  alternatives: RouteAlternative[];

  /**
   * @generated from field: repeated string warnings = 18;
   */
  warnings: string[];

  /**
   * What the drawn route actually runs on, for the road controls that were
   * answered: which motorways and toll roads it uses, or that it uses none.
   *
   * Carried apart from warnings because these are not warnings — they are the
   * answer to "did the control do anything", which a route's shape cannot
   * give: an arterial and a motorway are drawn alike, and a city with no toll
   * road looks exactly like a toll preference that was ignored.
   *
   * Apart, too, because the alternative was matching the prose. The web app
   * picked these out of warnings with a regular expression over the first few
   * words, and it matched three of the twelve sentences this can produce — so
   * "No toll road is used on this route" was written on every such plan and
   * shown on none of them.
   *
   * @generated from field: repeated string road_notes = 20;
   */
  roadNotes: string[];

  /**
   * What the DRAWN line runs on, for the road that was asked for — the figure
   * each alternative's road_answer is measured against. Empty when no road
   * control was answered.
   *
   * @generated from field: string road_answer = 19;
   */
  roadAnswer: string;
};

/**
 * Describes the message travplaces.v1.RoutePlan.
 * Use `create(RoutePlanSchema)` to create a new message.
 */
export const RoutePlanSchema: GenMessage<RoutePlan> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 27);

/**
 * StopRecommendation is a ranked candidate offered before anything is planned.
 *
 * @generated from message travplaces.v1.StopRecommendation
 */
export type StopRecommendation = Message<"travplaces.v1.StopRecommendation"> & {
  /**
   * @generated from field: string poi_id = 1;
   */
  poiId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string category_key = 3;
   */
  categoryKey: string;

  /**
   * @generated from field: string category_label = 4;
   */
  categoryLabel: string;

  /**
   * @generated from field: double lat = 5;
   */
  lat: number;

  /**
   * @generated from field: double lng = 6;
   */
  lng: number;

  /**
   * @generated from field: optional string address = 7;
   */
  address?: string | undefined;

  /**
   * @generated from field: int32 dwell_minutes = 8;
   */
  dwellMinutes: number;

  /**
   * 0..1, relative to the best candidate in this corridor.
   *
   * @generated from field: double score = 9;
   */
  score: number;

  /**
   * @generated from field: optional double rating = 10;
   */
  rating?: number | undefined;

  /**
   * @generated from field: optional int32 user_rating_count = 11;
   */
  userRatingCount?: number | undefined;

  /**
   * Confirmed against the place provider. Not the same as having a rating.
   *
   * @generated from field: bool verified = 12;
   */
  verified: boolean;

  /**
   * Minutes this adds to the journey, there and back. Unset when it could not
   * be routed, and for transit.
   *
   * @generated from field: optional double detour_minutes = 13;
   */
  detourMinutes?: number | undefined;

  /**
   * Which break this was suggested for: "lunch" | "coffee", or unset.
   *
   * @generated from field: optional string break_role = 14;
   */
  breakRole?: string | undefined;
};

/**
 * Describes the message travplaces.v1.StopRecommendation.
 * Use `create(StopRecommendationSchema)` to create a new message.
 */
export const StopRecommendationSchema: GenMessage<StopRecommendation> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 28);

/**
 * ThemeAlternative is one theme's rendering of the same journey. Mirrors the
 * legacy /plan/themes alternatives array.
 *
 * @generated from message travplaces.v1.ThemeAlternative
 */
export type ThemeAlternative = Message<"travplaces.v1.ThemeAlternative"> & {
  /**
   * @generated from field: string theme = 1;
   */
  theme: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * Unset when this theme could not be planned; error then says why.
   *
   * @generated from field: optional travplaces.v1.RoutePlan plan = 3;
   */
  plan?: RoutePlan | undefined;

  /**
   * @generated from field: optional string error = 4;
   */
  error?: string | undefined;
};

/**
 * Describes the message travplaces.v1.ThemeAlternative.
 * Use `create(ThemeAlternativeSchema)` to create a new message.
 */
export const ThemeAlternativeSchema: GenMessage<ThemeAlternative> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 29);

/**
 * @generated from message travplaces.v1.PlanResponse
 */
export type PlanResponse = Message<"travplaces.v1.PlanResponse"> & {
  /**
   * @generated from field: travplaces.v1.RoutePlan plan = 1;
   */
  plan?: RoutePlan | undefined;
};

/**
 * Describes the message travplaces.v1.PlanResponse.
 * Use `create(PlanResponseSchema)` to create a new message.
 */
export const PlanResponseSchema: GenMessage<PlanResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 30);

/**
 * @generated from message travplaces.v1.PlanCoverageResponse
 */
export type PlanCoverageResponse = Message<"travplaces.v1.PlanCoverageResponse"> & {
  /**
   * @generated from field: double radius_m = 1;
   */
  radiusM: number;

  /**
   * How far apart the ends are, so "why is it a circle?" answers itself.
   *
   * @generated from field: double span_m = 2;
   */
  spanM: number;

  /**
   * @generated from field: bool round_trip = 3;
   */
  roundTrip: boolean;

  /**
   * The buffered corridor straight from PostGIS, as a GeoJSON string.
   *
   * @generated from field: string area_geojson = 4;
   */
  areaGeojson: string;
};

/**
 * Describes the message travplaces.v1.PlanCoverageResponse.
 * Use `create(PlanCoverageResponseSchema)` to create a new message.
 */
export const PlanCoverageResponseSchema: GenMessage<PlanCoverageResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 31);

/**
 * @generated from message travplaces.v1.PlanRecommendationsResponse
 */
export type PlanRecommendationsResponse = Message<"travplaces.v1.PlanRecommendationsResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.StopRecommendation stops = 1;
   */
  stops: StopRecommendation[];

  /**
   * @generated from field: repeated travplaces.v1.StopRecommendation lunch = 2;
   */
  lunch: StopRecommendation[];

  /**
   * @generated from field: repeated travplaces.v1.StopRecommendation coffee = 3;
   */
  coffee: StopRecommendation[];
};

/**
 * Describes the message travplaces.v1.PlanRecommendationsResponse.
 * Use `create(PlanRecommendationsResponseSchema)` to create a new message.
 */
export const PlanRecommendationsResponseSchema: GenMessage<PlanRecommendationsResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 32);

/**
 * @generated from message travplaces.v1.PlanThemesResponse
 */
export type PlanThemesResponse = Message<"travplaces.v1.PlanThemesResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.ThemeAlternative alternatives = 1;
   */
  alternatives: ThemeAlternative[];
};

/**
 * Describes the message travplaces.v1.PlanThemesResponse.
 * Use `create(PlanThemesResponseSchema)` to create a new message.
 */
export const PlanThemesResponseSchema: GenMessage<PlanThemesResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_planning, 33);

/**
 * PlanningService plans routes and answers the pre-plan side queries.
 *
 * @generated from service travplaces.v1.PlanningService
 */
export const PlanningService: GenService<{
  /**
   * Plan builds one route from a PlanRequest.
   *
   * @generated from rpc travplaces.v1.PlanningService.Plan
   */
  plan: {
    methodKind: "unary";
    input: typeof PlanRequestSchema;
    output: typeof PlanResponseSchema;
  },
  /**
   * PlanCoverage returns the ground a plan would search, as geometry, without
   * planning or looking anything up.
   *
   * @generated from rpc travplaces.v1.PlanningService.PlanCoverage
   */
  planCoverage: {
    methodKind: "unary";
    input: typeof PlanRequestSchema;
    output: typeof PlanCoverageResponseSchema;
  },
  /**
   * PlanRecommendations ranks what the corridor offers without planning.
   *
   * @generated from rpc travplaces.v1.PlanningService.PlanRecommendations
   */
  planRecommendations: {
    methodKind: "unary";
    input: typeof PlanRequestSchema;
    output: typeof PlanRecommendationsResponseSchema;
  },
  /**
   * PlanThemes plans the same journey once per theme so they can be compared.
   *
   * @generated from rpc travplaces.v1.PlanningService.PlanThemes
   */
  planThemes: {
    methodKind: "unary";
    input: typeof PlanRequestSchema;
    output: typeof PlanThemesResponseSchema;
  },
  /**
   * PlanDirections turns a plan that has already been made into turn-by-turn
   * directions. One router call, no optimiser, and only when somebody asks
   * for a file.
   *
   * @generated from rpc travplaces.v1.PlanningService.PlanDirections
   */
  planDirections: {
    methodKind: "unary";
    input: typeof PlanDirectionsRequestSchema;
    output: typeof PlanDirectionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_planning, 0);

